module.exports = __webpack_public_path__ + "img/logo.df21952f.png";